import React from "react";
import Icon from "@gc-npm/components.icon-glyph";
import style from "./style";

const RowFake = () => {
  return (
    <>
      <div className="fake-filters--row">
        <div className="skeleton fake-filters--row--medium" />
        <Icon id="cheuron-down-m" width={16} color="GREY_400" />
      </div>
      <div className="fake-filters--checks">
        <div className="skeleton fake-filters--row--medium" />
        <div className="fake-filters--row--check" />
      </div>
      <div className="fake-filters--checks">
        <div className="skeleton fake-filters--row--medium" />
        <div className="fake-filters--row--check" />
      </div>
      <div className="fake-filters--checks">
        <div className="skeleton fake-filters--row--medium" />
        <div className="fake-filters--row--check" />
      </div>
      <div className="fake-filters--checks">
        <div className="skeleton fake-filters--row--small" />
      </div>
      <style jsx>{style}</style>
    </>
  );
};
const FakeFilters = () => {
  return (
    <>
      <div className="fake-filters">
        <div className="fake-filters--search">
          <div
            className="skeleton fake-filters--row--small display-desktop"
            style={{ marginBottom: "20px" }}
          />
          <div
            className="skeleton fake-filters--box"
            style={{ height: "45px", width: "100%" }}
          />
        </div>
        <div className="fake-filters--buttons">
          <div
            className="skeleton fake-filters--box"
            style={{
              height: "22px",
              width: "50px",
              marginRight: "5px",
              borderRadius: "8px",
            }}
          />{" "}
          <div
            className="skeleton fake-filters--box"
            style={{
              height: "22px",
              width: "65px",
              marginRight: "5px",
              borderRadius: "8px",
            }}
          />{" "}
          <div
            className="skeleton fake-filters--box"
            style={{ height: "22px", width: "60px", borderRadius: "8px" }}
          />
        </div>
        <div className="fake-filters--group">
          <RowFake />
          <RowFake />
          <div className="fake-filters--row">
            <div className="skeleton fake-filters--row--medium" />
            <Icon id="cheuron-down-m" width={16} color="GREY_400" />
          </div>
          <div className="fake-filters--row">
            <div className="skeleton fake-filters--row--medium" />
            <Icon id="cheuron-down-m" width={16} color="GREY_400" />
          </div>
          <div className="fake-filters--row">
            <div className="skeleton fake-filters--row--medium" />
            <Icon id="cheuron-down-m" width={16} color="GREY_400" />
          </div>
          <div className="fake-filters--row">
            <div className="skeleton fake-filters--row--medium" />
            <Icon id="cheuron-down-m" width={16} color="GREY_400" />
          </div>
          <div className="fake-filters--row">
            <div className="skeleton fake-filters--row--medium" />
            <Icon id="cheuron-down-m" width={16} color="GREY_400" />
          </div>
          <div className="fake-filters--row">
            <div className="skeleton fake-filters--row--medium" />
            <Icon id="cheuron-down-m" width={16} color="GREY_400" />
          </div>
          <div className="fake-filters--row">
            <div className="skeleton fake-filters--row--medium" />
            <Icon id="cheuron-down-m" width={16} color="GREY_400" />
          </div>
          <div className="fake-filters--row">
            <div className="skeleton fake-filters--row--medium" />
            <Icon id="cheuron-down-m" width={16} color="GREY_400" />
          </div>
        </div>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default FakeFilters;
